import './PromoBanner.scss';
import Component from './PromoBanner.js';
export default Component;
